import React from 'react'
import HeaderAdmin from "../../Components/HeaderAdmin";
import usePedidos from '../../Hooks/usePedidos';

const DeliveryAdmin = () => 
{
    const Pedidos=usePedidos();
    return (
        <div>
            <HeaderAdmin title={"Pedidos"}/>
            {Pedidos.map(pedido =>
            {
               const {data}=pedido;
               const {Clasificacion,Nombre,Direccion,Pago,Orden}=data;
                return <div style={{margin:"10px"}}>
                    <p>{Nombre} - {Clasificacion}</p>
                    <p>{Direccion}</p>
                    <p>{Pago}</p>
                </div>
            })}
        </div>
    )
}

export default DeliveryAdmin
